// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see MarketingFaqToggleOpenEvent
 */
export var MarketingFaqToggleOpen = function (_a) {
    var faqIdentifier = _a.faqIdentifier;
    return ({
        name: "MarketingFaq Toggle Open",
        parameters: {
            cdf_entity: "MarketingFaq",
            cdf_action: "Toggle",
            faq_identifier: faqIdentifier !== undefined && faqIdentifier !== null ? faqIdentifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
